import { useMemo } from "react";
import { useFormikContext } from "formik";
import usePluginEntities from "hooks/usePluginEntities";
const useCommandsContext = (usage) => {
  const contextProviders = usePluginEntities("views.queryInput.commandContextProviders");
  const formikContext = useFormikContext();
  const context = Object.fromEntries(contextProviders.map(({ key, provider }) => [key, provider(formikContext)]));
  return { ...context, usage };
};
const usePluggableCommands = (usage) => {
  const pluggableCommands = usePluginEntities("views.queryInput.commands");
  const commandsForUsage = useMemo(
    () => pluggableCommands.filter(({ usages = [] }) => usages.includes(usage)),
    [pluggableCommands, usage]
  );
  const context = useCommandsContext(usage);
  return useMemo(
    () => commandsForUsage.map(({ name, bindKey, exec: commandExec }) => ({
      name,
      bindKey,
      exec: (editor) => commandExec(editor, context)
    })),
    [commandsForUsage, context]
  );
};
export default usePluggableCommands;
